import mqtt from 'mqtt'
import type { MqttClient } from 'mqtt'
import { useAuthStore } from '@/stores/authStore.ts'

const getConnectionConfig = () => {
  const auth = useAuthStore()
  const token = auth.auth.mqttToken
  const userInfo = auth.auth.userInfo
  const username = userInfo?.userName || ''
  return {
    host: (import.meta as any).env.VITE_MQTT_URL,
    port: (import.meta as any).env.VITE_MQTT_PORT,
    endpoint: '/mqtt',
    clean: true,
    connectTimeout: 1000,
    clientId: `mqtt_client_${Math.random().toString(16).substring(2, 10)}`,
    // iamUsername: iamUsername,
    // mqttToken: token,
    // username: import.meta.env.VITE_MQTT_USERNAME,
    // password: import.meta.env.VITE_MQTT_PASSWORD,
    username: username,
    password: token,
    reconnectPeriod: 1000
  }
}

let mqttClient: MqttClient | null = null
let onMessageCallback: ((topic: string, message: any) => void) | null = null

const connect = () => {
  if (!mqttClient) {
    const connection = getConnectionConfig()
    const { host, port, endpoint, ...options } = connection
    const connectUrl = `${host}:${port}${endpoint}`

    mqttClient = mqtt.connect(connectUrl, options)

    mqttClient.on('connect', () => {
      console.log('MQTT connected successfully')
    })

    mqttClient.on('message', (topic, message) => {
      if (onMessageCallback && message) {
        const parsedMessage = JSON.parse(message.toString())
        onMessageCallback(topic, parsedMessage)
      }
    })

    mqttClient.on('error', (error) => {
      console.error('MQTT connection error:', error)
    })
  }
}

export default {
  connect,

  subscribe: (topic: string, options?: any, callback?: (error: any, granted: any) => void) => {
    if (!mqttClient) {
      connect()
    }
    if (!options) {
      options = { qos: 1 }
    }
    if (!callback) {
      callback = (error) => {
        if (error) {
          console.log('Subscribe error', error)
        }
      }
    }
    mqttClient.subscribe(topic, options, callback)
    // console.log(`Subscribed to topic: ${topic}`)
  },

  unsubscribe: (topic: string) => {
    if (!mqttClient) {
      connect()
    }
    mqttClient.unsubscribe(topic, (error) => {
      if (error) {
        console.log('Unsubscribe error', error)
      }
    })
  },

  publish: (topic: string, message: string) => {
    if (!mqttClient) {
      connect()
    }
    mqttClient.publish(topic, message)
    // console.log(`Published message to topic: ${topic}, message: ${message}`)
  },

  disconnect: () => {
    if (mqttClient) {
      mqttClient.end()
      // console.log('Disconnected from MQTT broker')
    }
  },

  onMessage: (callback: (topic: string, message: any) => void) => {
    onMessageCallback = callback
  },

  isConnected: (): boolean => {
    return mqttClient?.connected || false
  }
}
